import React, {useMemo} from "react";
import {object as objectType} from "prop-types";

const getChild = children => (Array.isArray(children) ? children[0] : children);

const DummyContext = React.createContext();

const DummyProvider = ({children}) => {
  const dummyCtx = useMemo(() => ({}), [])
  return <DummyContext.Provider value={dummyCtx}>{children}</DummyContext.Provider>;
};

DummyProvider.propTypes = {
  children: objectType,
}

/* https://github.com/baptistelambert/react-combine-contexts */
export const combineContexts = contexts => {
  if (!contexts || !Object.keys(contexts).length) {
    return {Provider: DummyProvider, Context: DummyContext};
  }

  return {
    Provider: ({children, value}) =>
      Object.values(contexts).reduce(
        (tree, Context) => (
          <Context.Provider value={value}>{tree}</Context.Provider>
        ),
        children
      ),
    Consumer: ({children}) =>
      Object.entries(contexts).reduce(
        (tree, [key, Context]) => values => (
          <Context.Consumer>
            {consumerValue =>
              tree({
                ...values,
                [key]: consumerValue
              })}
          </Context.Consumer>
        ),
        value => getChild(children)(value)
      )()
  };
};

export const isUnentitled = authData => {
  if (!authData) {
    return false;
  }

  const {org = {}} = authData,
    {"activation-status": activationStatus, "scim-status": scimStatus} = org;

  return (
    activationStatus === "waiting-activation" ||
    scimStatus === "waiting-activation" ||
    (!activationStatus && !scimStatus)
  );
};
